module.exports = __webpack_public_path__ + "img/bottom-2.a40823e9.png";